// AML screens show every date as YYYY-MM-DD, the form the API already returns for plain dates
// (due dates, review dates, the appointment date). A timestamp is cut to its calendar day in the
// viewer's time zone, so lists, the approval steps and the version history all read the same.
export const formatDay = (value) => {
  if (!value) return '—';
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
